<template>
  <div>
    <WealthStockAssignments />
    <v-alert
      v-if="dialogUrladungAlert"
      text="Urladung nicht erfolgreich"
      title="Alert"
      type="info"
      variant="tonal"
      closable
      class="mb-3"
    />

    <v-card class="mb-4">
      <v-card-actions class="stocks-actions">
        <v-menu
          v-model="stockSheet"
          :close-on-content-click="false"
          location="bottom start"
        >
          <template #activator="{ props }">
            <v-btn
              v-bind="props"
              icon="mdi-format-list-bulleted"
              color="primary"
              elevation="4"
            />
          </template>

          <v-card class="stock-menu-card">
            <v-card-title class="text-subtitle-1 py-3">
              Stocks
            </v-card-title>
            <v-card-text>
              <div class="stock-selector-wrap stock-selector-wrap--sheet">
                <v-btn
                  v-for="stockitem in displayedStocks"
                  :key="'sheet-' + (stockitem.idstocks || stockitem.stocks_name)"
                  :color="getCardcolor(stockitem)"
                  variant="flat"
                  density="compact"
                  class="stock-btn"
                  :style="{ color: getShortcutTextColor(stockitem) }"
                  @click.stop="goToStockFromSheet(stockitem)"
                >
                  {{ (stockitem.stocks_name || '').substring(0, 3) }}
                </v-btn>
              </div>
            </v-card-text>
          </v-card>
        </v-menu>

        <v-btn
          prepend-icon="mdi-file-pdf-box"
          color="deep-orange-darken-2"
          variant="flat"
          class="pdf-import-toolbar-btn"
          @click="openPdfImportDialog"
        >
          PDF Import
        </v-btn>

        <v-btn
          prepend-icon="mdi-plus-circle-outline"
          color="primary"
          variant="flat"
          class="create-stock-toolbar-btn"
          @click="createStockGUI()"
        >
          create new Stock
        </v-btn>

        <v-spacer />

        <v-switch
          v-model="zeigeStocksAllerUser"
          class="stocks-user-filter"
          color="primary"
          density="compact"
          hide-details
          inset
          label="Alle User"
        />
      </v-card-actions>
    </v-card>

    <v-alert v-model="alert" type="error" closable class="mb-3">
      Fehler beim Speichern.
    </v-alert>

    <div ref="scrollContainer" class="stocks-scroll-wrap">
      <v-expansion-panels
          v-model="expandedPanels"
          multiple
          variant="accordion"
        >
        <v-expansion-panel
          v-for="item in displayedStocks"
          :key="item.localKey"
          :value="item.localKey"
          :bg-color="getCardcolor(item)"
        >
          <v-expansion-panel-title>
            <div
              :ref="el => setStockRef(item.idstocks, el)"
              class="stock-anchor"
            >
              <v-row align="center" no-gutters class="w-100">
                <v-avatar class="mr-3">
                  <v-img
                    :src="getSymbolSrc(item)"
                    alt="Avatar"
                    :key="`img-${item.idstocks}-${imageVersions[item.idstocks] || 0}`"
                  />
                </v-avatar>

                <div class="stock-panel-title-text">
                  <div class="stock-title-row">
                    <div class="stock-title">
                      {{ item.stocks_name || 'Unbenannt' }}
                    </div>

                    <v-chip
                      v-if="getStrategyTag(item)"
                      size="x-small"
                      class="ml-2"
                      :color="getStrategyTag(item).color"
                      :variant="getStrategyTag(item).variant"
                    >
                      {{ getStrategyTag(item).label }}
                    </v-chip>

                  </div>

                  <div class="stock-subtitle">
                    {{ item.stocks_Typ || 'Aktie' }}
                    |
                    Menge: {{ item.stocks_Menge }}
                    |
                    Wert:
                    <span class="stock-value-header">{{ getGesamtwert(item) }}</span>
                    |
                    User: {{ item.user_iduser?.user_username || '-' }}
                  </div>
                </div>

                <v-spacer />

                <v-chip
                  size="small"
                  :color="getCardcolor(item)"
                  variant="flat"
                >
                  {{ item.stocks_Land || '-' }}
                </v-chip>
              </v-row>
            </div>
          </v-expansion-panel-title>

          <v-expansion-panel-text>
            <v-card :color="getCardcolor(item)">
              <v-card-title>
                <v-row align="center" class="spacer" no-gutters>
                  <v-avatar>
                    <v-img
                      :src="getSymbolSrc(item)"
                      alt="Avatar"
                      :key="`img2-${item.idstocks}-${imageVersions[item.idstocks] || 0}`"
                    />
                  </v-avatar>

                  <v-text-field
                    v-model="item.stocks_name"
                    label="Name"
                    class="ml-3"
                    hide-details
                  />
                </v-row>
              </v-card-title>

              <v-container fluid>
                <v-row dense no-gutters>
                  <v-text-field
                    label="UserName"
                    :model-value="item.user_iduser?.user_username"
                    readonly
                  />

                  <v-text-field
                    label="Handelsplatz"
                    hint="ETR"
                    v-model="item.stocks_Handelsplatz"
                    required
                  />

                  <v-text-field
                    label="GoogleID"
                    hint="DTE"
                    v-model="item.stocks_GoogleId"
                    required
                  />

                  <v-text-field
                    label="Realisiert"
                    v-model="item.stock_Realsiert"
                    readonly
                  />

                  <v-select
                    label="Land"
                    v-model="item.stocks_Land"
                    :items="laender"
                    item-title="land"
                    item-value="wert"
                  />

                  <v-text-field
                    hint="DE34542534254"
                    v-model="item.stocks_ISIN"
                    label="ISIN"
                  />
                </v-row>

                <v-row dense no-gutters>
                  <v-text-field
                    hint="für Google table als Id notwendig"
                    v-model="item.idstocks"
                    label="ID stock"
                    readonly
                  />

                  <v-text-field
                    label="Menge"
                    hint="10.65"
                    v-model="item.stocks_Menge"
                  />

                  <v-select
                    label="Typ"
                    v-model="item.stocks_Typ"
                    :items="['Aktie','ETF','Fonds','Krypto','Rohstoff','Cash']"
                  />

                  <v-text-field
                    label="Kaufkurs"
                    hint="145.65"
                    v-model="item.stocks_Kaufkurs"
                  />

                  <v-text-field
                    label="Kaufdatum"
                    hint="2018-04-20"
                    v-model="item.stocks_Kaufdatum"
                  />
                </v-row>

                <v-row no-gutters>
                  <v-text-field
                    label="AktuellerKurs"
                    v-model="item.stock_Aktuellerkurs"
                  />

                  <v-text-field
                    label="StopLoss"
                    v-model="item.stocks_stoploss"
                  />

                  <v-text-field
                    label="SL Gültig bis"
                  />

                  <v-text-field
                    label="UmrechnungsKurs"
                    v-model="item.stock_Umrechnungskurs"
                  />
                </v-row>

                <v-row no-gutters class="ga-2">
                  <v-btn
                    v-if="!isCreateItem(item)"
                    @click="openBuyDialog(item)"
                    prepend-icon="mdi-cart-plus"
                    color="grey-darken-4"
                    variant="flat"
                    style="color: #ffffff"
                  >
                    buy
                  </v-btn>

                  <v-btn
                    v-if="!isCreateItem(item)"
                    @click="openSellDialog(item)"
                    prepend-icon="mdi-cart-minus"
                    color="grey-darken-4"
                    variant="flat"
                    style="color: #ffffff"
                  >
                    sell
                  </v-btn>

                  <v-btn
                    v-if="!isCreateItem(item) && isCashStock(item)"
                    prepend-icon="mdi-cash-plus"
                    color="green-darken-2"
                    variant="flat"
                    style="color: #ffffff"
                    @click="openCashDialog(item)"
                  >
                    Cash
                  </v-btn>

                  <v-btn
                    v-if="!isCreateItem(item)"
                    prepend-icon="mdi-chart-line"
                    color="secondary"
                    variant="flat"
                    style="color: #ffffff"
                    @click="goToAnalyzer(item)"
                  >
                    Analyzer
                  </v-btn>

                  <v-btn
                    v-if="!isCreateItem(item)"
                    @click="updateStockOnDB(item)"
                    prepend-icon="mdi-content-save"
                    color="grey-darken-4"
                    variant="flat"
                    style="color: #ffffff"
                  >
                    save
                  </v-btn>

                  <v-btn
                    v-if="item.isNew"
                    prepend-icon="mdi-plus-circle-outline"
                    color="green-lighten-2"
                    variant="flat"
                    class="create-stock-submit-btn"
                    @click="createStockOnDB(item)"
                  >
                    create
                  </v-btn>

                  <v-btn
                    v-if="!isCreateItem(item)"
                    prepend-icon="mdi-file-restore"
                    color="orange"
                    variant="flat"
                    style="color: #111111"
                    @click="urladungStockOnDB(item)"
                  >
                    Urladung
                  </v-btn>

                  <v-btn
                    v-if="!isCreateItem(item)"
                    prepend-icon="mdi-upload"
                    color="orange"
                    variant="flat"
                    style="color: #111111"
                    @click="openUploadDialog(item)"
                  >
                    Symbol hochladen
                  </v-btn>

                  <v-btn
                    v-if="!isCreateItem(item)"
                    prepend-icon="mdi-delete"
                    color="red"
                    variant="flat"
                    style="color: #ffffff"
                    @click="openDeleteDialog(item)"
                  >
                    delete
                  </v-btn>
                </v-row>
              </v-container>
            </v-card>
          </v-expansion-panel-text>
        </v-expansion-panel>
      </v-expansion-panels>
    </div>

    <!-- Global Loading Dialog -->
    <v-dialog
      v-model="dialogUrladungRunning"
      max-width="320"
      persistent
    >
      <v-list
        class="py-2"
        color="primary"
        elevation="12"
        rounded="lg"
      >
        <v-list-item title="Urladung...">
          <template #prepend>
            <div class="pe-4">
              <v-icon color="primary" size="x-large"></v-icon>
            </div>
          </template>

          <template #append>
            <v-progress-circular
              color="primary"
              indeterminate="disable-shrink"
              size="16"
              width="2"
            />
          </template>
        </v-list-item>
      </v-list>
    </v-dialog>

    <PdfTransactionImportDialog
      ref="pdfTransactionImport"
      mode="dialog"
      @imported="onPdfTransactionImported"
    />

    <!-- Global Delete Dialog -->
    <v-dialog v-model="deleteDialog" max-width="500px">
      <v-card>
        <v-card-title class="headline">Löschen bestätigen</v-card-title>
        <v-card-text>
          Bist du sicher, dass du den Stock
          "{{ selectedStock?.stocks_name }}" löschen möchtest?
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn color="blue-darken-1" variant="text" @click="closeDeleteDialog">
            Abbrechen
          </v-btn>
          <v-btn color="red-darken-1" variant="text" @click="confirmDeleteStock">
            Löschen
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Global Upload Dialog -->
    <v-dialog v-model="uploadDialog" max-width="600px">
      <v-card>
        <v-card-title>Symbol hochladen</v-card-title>
        <v-card-text>
          <div class="mb-3">
            Stock:
            <strong>{{ uploadStock?.stocks_name || '-' }}</strong>
          </div>

          <v-file-input
            label="StockSymbol File input"
            variant="filled"
            prepend-icon="mdi-file"
            accept="image/*"
            @change="onUploadFileSelected"
          />
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn variant="text" @click="closeUploadDialog">Cancel</v-btn>
          <v-btn
            color="primary"
            :disabled="!uploadFile || !uploadStock"
            @click="confirmUploadSymbol"
          >
            Upload
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Buy Dialog -->
    <v-dialog v-model="dialog" max-width="500px">
      <v-card>
        <v-card-title>
          <span class="headline">Zukaufen von Anteilen</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-text-field v-model="editedItem.menge" label="Menge" hint="1.2" />

              <v-text-field
                v-model="editedItem.preis"
                @input="convertCommaToDot"
                label="Ver/Kauf-Preis PRO Stock"
                hint="(immer positiv) in Euro pro Stück"
              />

              <v-text-field
                v-model="editedItem.provision"
                label="Provision+Steuer"
                hint="meist bei Sparplan separat in Euro"
              />
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn color="blue-darken-1" @click="close">Cancel</v-btn>
          <v-btn color="blue-darken-1" @click="createTransaction(1)">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Sell Dialog -->
    <v-dialog v-model="dialogSubtract" max-width="500px">
      <v-card>
        <v-card-title>
          <span class="headline">Verkaufen von Anteilen</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-text-field v-model="editedItem.menge" label="Menge" hint="1.2" />

              <v-text-field
                v-model="editedItem.preis"
                @input="convertCommaToDot"
                label="Ver/Kauf-Preis PRO Stock"
                hint="(immer positiv) in Euro pro Stück"
              />

              <v-text-field
                v-model="editedItem.provision"
                label="Kosten (Gebuehr + Steuer)"
                hint="meist bei Sparplan separat in Euro"
              />
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn color="blue-darken-1" @click="close">Cancel</v-btn>
          <v-btn color="blue-darken-1" @click="createTransaction(2)">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Cash Dialog -->
    <v-dialog v-model="cashDialog" max-width="520px">
      <v-card>
        <v-card-title>
          <span class="headline">Cash Ein-/Auszahlung</span>
        </v-card-title>
        <v-card-text>
          <div class="mb-3">
            Stock:
            <strong>{{ cashStock?.stocks_name || '-' }}</strong>
          </div>

          <v-container class="pa-0">
            <v-row dense>
              <v-col cols="12" md="6">
                <v-select
                  v-model="cashForm.category"
                  :items="cashCategoryOptions"
                  item-title="title"
                  item-value="value"
                  label="Typ"
                  density="compact"
                  @update:model-value="onCashCategoryChange"
                />
              </v-col>

              <v-col cols="12" md="6">
                <v-text-field
                  v-model="cashForm.amount"
                  label="Betrag"
                  hint="immer positiv in Euro"
                  density="compact"
                  @input="convertCashAmountCommaToDot"
                />
              </v-col>

              <v-col cols="12" md="6">
                <v-text-field
                  v-model="cashForm.date"
                  label="Datum"
                  type="date"
                  density="compact"
                />
              </v-col>

              <v-col cols="12">
                <v-text-field
                  v-model="cashForm.description"
                  label="Beschreibung"
                  density="compact"
                />
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn variant="text" @click="closeCashDialog">Cancel</v-btn>
          <v-btn
            color="primary"
            variant="flat"
            :disabled="!canSaveCashTransaction"
            @click="saveCashTransaction"
          >
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- TX Result -->
    <v-dialog v-model="txResultDialog" max-width="700">
      <v-card>
        <v-card-title>DB-Rückmeldung</v-card-title>

        <v-card-text>
          <v-table density="compact">
            <tbody>
              <tr v-for="[k, v] in txSummaryEntries" :key="k">
                <td style="width: 260px; font-weight: 600;">{{ k }}</td>
                <td>{{ v }}</td>
              </tr>
            </tbody>
          </v-table>

          <v-btn
            class="mt-4"
            size="small"
            variant="outlined"
            prepend-icon="mdi-code-json"
            @click="showRawTxJson = !showRawTxJson"
          >
            {{ showRawTxJson ? 'JSON ausblenden' : 'Komplettes JSON anzeigen' }}
          </v-btn>

          <v-expand-transition>
            <div v-if="showRawTxJson" class="mt-4">
              <div style="font-weight: 600;">Raw JSON</div>
              <pre style="white-space: pre-wrap;">{{ JSON.stringify(txResult, null, 2) }}</pre>
            </div>
          </v-expand-transition>
        </v-card-text>

        <v-card-actions>
          <v-spacer />
          <v-btn @click="txResultDialog = false">OK</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import axios from '@/api/client'
import PdfTransactionImportDialog from '@/components/PdfTransactionImportDialog.vue'
import WealthStockAssignments from '@/components/WealthStockAssignments.vue'

export default {
  name: 'StocksScreen',
  components: {
    WealthStockAssignments,
    PdfTransactionImportDialog
  },

  data() {
    return {
      txResultDialog: false,
      txResult: null,
      txResultError: null,
      showRawTxJson: false,

      deleteDialog: false,
      selectedStock: null,

      uploadDialog: false,
      uploadStock: null,
      uploadFile: null,

      cashDialog: false,
      cashStock: null,
      cashCategoryOptions: [
        { title: 'Einzahlung', value: 5 },
        { title: 'Auszahlung', value: 6 }
      ],
      cashForm: {
        category: 5,
        amount: '',
        date: '',
        description: 'Cash Einzahlung'
      },

      zeigeStocksAllerUser: false,
      aktuellerUser: '',
      CreateModus: false,

      expandedPanels: [],

      laender: [
        { land: 'Argentinien', wert: 'Argentinien' },
        { land: 'Australien', wert: 'Australien' },
        { land: 'China', wert: 'China' },
        { land: 'Dänemark', wert: 'Dänemark' },
        { land: 'Deutschland', wert: 'Deutschland' },
        { land: 'Europa', wert: 'Europa' },
        { land: 'Frankreich', wert: 'Frankreich' },
        { land: 'Italien', wert: 'Italien' },
        { land: 'Japan', wert: 'Japan' },
        { land: 'Kanada', wert: 'Kanada' },
        { land: 'Niederlande', wert: 'Niederlande' },
        { land: 'Norwegen', wert: 'Norwegen' },
        { land: 'Schweden', wert: 'Schweden' },
        { land: 'Schweiz', wert: 'Schweiz' },
        { land: 'Südkorea', wert: 'Südkorea' },
        { land: 'Taiwan', wert: 'Taiwan' },
        { land: 'Uruguay', wert: 'Uruguay' },
        { land: 'USA', wert: 'USA' },
        { land: 'Welt', wert: 'Welt' },
      ],

      dialog: false,
      dialogUrladungRunning: false,
      dialogUrladungAlert: false,
      dialogSubtract: false,
      stockSheet: false,

      editedIndex: -1,
      editedItem: {
        typ: 2,
        key: -1,
        preis: 0,
        datum: 0,
        menge: 0,
        beschreibung: '',
        stocks_idstocks: 0,
        indexListe: -1,
        indextable: -1,
        aenderungskennzeichen: -1,
        provision: 0
      },

      defaultEditedItem: {
        typ: 2,
        key: -1,
        preis: 0,
        datum: 0,
        menge: 0,
        beschreibung: '',
        stocks_idstocks: 0,
        indexListe: -1,
        indextable: -1,
        aenderungskennzeichen: -1,
        provision: 0
      },

      alert: false,
      imageVersions: {},
      editableStocks: [],
      stockRefs: {},
      newStockCounter: 0
    }
  },

  computed: {
    ...mapGetters({
      stocks: 'stateStocks',
      users: 'stateUser',
      preisdeltasAll: 'statePreisdeltasAll'
    }),

    displayedStocks() {
      return this.editableStocks.filter(item => {
        return (
          this.zeigeStocksAllerUser ||
          this.users.iduser !== 1 ||
          (this.users.iduser === 1 && item.user_iduser?.iduser === 1)
        )
      })
    },

    txSummaryEntries() {
      const transaction = this.txResult?.transaction ?? {}
      const stockAfter = this.txResult?.stock_after ?? {}

      return [
        ['Preis', this.formatTxValue(transaction?.stocks_transactions_preisV02, '€')],
        ['MengeNeu', this.formatTxValue(stockAfter?.stocks_Menge, 'Stück')]
      ]
    },

    canSaveCashTransaction() {
      const amount = Number(String(this.cashForm.amount || '').replace(',', '.'))
      return Boolean(this.cashStock?.idstocks) && Number.isFinite(amount) && amount > 0
    },

    strategyByStockId() {
      const rows = Array.isArray(this.preisdeltasAll) ? this.preisdeltasAll : []

      return rows.reduce((acc, row) => {
        const stockId = Number(row?.stock_id)
        if (Number.isFinite(stockId)) {
          acc[stockId] = row
        }
        return acc
      }, {})
    }
  },

  watch: {
    stocks: {
      immediate: true,
      deep: true,
      handler(newStocks) {
        const createdItems = this.editableStocks.filter(item => item.isNew)

        const cloned = (newStocks || []).map(stock => ({
          ...this.deepClone(stock),
          localKey: `db-${stock.idstocks}`,
          isNew: false
        }))

        this.editableStocks = [...createdItems, ...cloned]

        this.$nextTick(() => {
          this.applyFocusedStockFromRoute()
        })
      }
    },
    '$route.query.focusStockId': {
      immediate: true,
      handler() {
        this.$nextTick(() => {
          this.applyFocusedStockFromRoute()
        })
      }
    }
  },

  async created() {
    await this.init()
  },

  methods: {
    ...mapActions([
      'createStock',
      'deleteStock',
      'updateStock',
      'createUploadSymbol'
    ]),

    async init() {
      try {
        await Promise.all([
          this.$store.dispatch('viewMe'),
          this.$store.dispatch('getStocks'),
          this.$store.dispatch('getPreisdeltasAll')
        ])

        this.$nextTick(() => {
          this.applyFocusedStockFromRoute()
        })
      } catch (error) {
        console.error('Initialisierung fehlgeschlagen', error)
      }
    },

    async goToStock(item) {
      if (!item) return

      const panelKey = item.localKey

      if (!this.expandedPanels.includes(panelKey)) {
        this.expandedPanels = [...this.expandedPanels, panelKey]
      }

      await this.$nextTick()

      setTimeout(() => {
        this.scrollTo(item.idstocks)
      }, 150)
    },

    async goToStockFromSheet(item) {
      this.stockSheet = false
      await this.$nextTick()

      setTimeout(() => {
        this.goToStock(item)
      }, 250)
    },

    applyFocusedStockFromRoute() {
      const focusId = Number(this.$route?.query?.focusStockId)
      if (!Number.isFinite(focusId) || focusId <= 0) return

      const item = this.displayedStocks.find(
        stock => Number(stock?.idstocks) === focusId
      )

      if (!item) return

      this.goToStock(item)
    },

    deepClone(obj) {
      return JSON.parse(JSON.stringify(obj))
    },

    getStrategyAnalysis(item) {
      const stockId = Number(item?.idstocks)
      if (!Number.isFinite(stockId)) return null
      return this.strategyByStockId?.[stockId] || null
    },

    getStrategyTag(item) {
      const analysis = this.getStrategyAnalysis(item)
      if (!analysis) return null

      const isLowQuality = String(analysis?.result_quality || '').toLowerCase() === 'low'

      if (analysis.better_strategy === 'actual_strategy') {
        return {
          label: isLowQuality ? 'Aktiv besser ?' : 'Aktiv besser',
          color: 'success',
          variant: isLowQuality ? 'outlined' : 'flat'
        }
      }

      if (analysis.better_strategy === 'buy_and_hold_benchmark') {
        return {
          label: isLowQuality ? 'Buy&Hold besser ?' : 'Buy&Hold besser',
          color: 'warning',
          variant: isLowQuality ? 'outlined' : 'flat'
        }
      }

      if (analysis.better_strategy === 'tie') {
        return {
          label: 'Gleich',
          color: 'grey',
          variant: 'outlined'
        }
      }

      return null
    },

    getStrategyOutperformance(item) {
      const analysis = this.getStrategyAnalysis(item)
      const value = Number(analysis?.outperformance_eur)

      if (!Number.isFinite(value)) return ''
      if (Math.abs(value) < 0.005) return ''

      return new Intl.NumberFormat('de-DE', {
        style: 'currency',
        currency: 'EUR',
        maximumFractionDigits: 0
      }).format(value)
    },

    getShortcutTextColor(item) {
      const color = this.getCardcolor(item)

      if (['orange', 'green', 'grey'].includes(color)) {
        return '#111111'
      }

      return '#ffffff'
    },

    formatTxValue(value, unit) {
      if (value === null || value === undefined || value === '') return '-'
      return `${value} ${unit}`
    },

getGesamtwert(item) {
  const menge = parseFloat(
    (item?.stocks_Menge ?? '0').toString().replace(',', '.')
  )

  const kurs = parseFloat(
    (item?.stock_Aktuellerkurs ?? '0').toString().replace(',', '.')
  )

  if (isNaN(menge) || isNaN(kurs)) return '0 €'

  const value = menge * kurs

  return value.toLocaleString('de-DE', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
  }) + ' €'
},

    setStockRef(id, el) {
      if (!id || !el) return
      this.stockRefs[id] = el
    },

    scrollTo(id) {
      const element = this.stockRefs[id]
      const container = this.$refs.scrollContainer

      if (!element) return

      if (container && container.contains(element)) {
        const containerRect = container.getBoundingClientRect()
        const elementRect = element.getBoundingClientRect()
        const offset = elementRect.top - containerRect.top + container.scrollTop - 8

        container.scrollTo({
          top: offset,
          behavior: 'smooth'
        })
        return
      }

      if (element.scrollIntoView) {
        element.scrollIntoView({ behavior: 'smooth', block: 'start' })
      }
    },
    isCreateItem(item) {
      return !!item.isNew || String(item.idstocks) === 'x'
    },

    isCashStock(item) {
      const typ = String(item?.stocks_Typ || '').trim().toLowerCase()
      const handelsplatz = String(item?.stocks_Handelsplatz || '').trim().toLowerCase()
      const name = String(item?.stocks_name || '').trim().toLowerCase()

      return typ === 'cash' || handelsplatz === 'typ_cash' || name.includes('cash')
    },

    todayIsoDate() {
      const now = new Date()
      const yyyy = now.getFullYear()
      const mm = String(now.getMonth() + 1).padStart(2, '0')
      const dd = String(now.getDate()).padStart(2, '0')
      return `${yyyy}-${mm}-${dd}`
    },

    convertCommaToDot(event) {
      let value = event.target.value.replace(',', '.')
      value = value.replace(/,/g, '.')
      value = value.replace(/[^0-9.]/g, '')
      value = value.replace(/^([^.]*\.)|\./g, '$1')
      this.editedItem.preis = value
    },

    convertCashAmountCommaToDot(event) {
      let value = event.target.value.replace(',', '.')
      value = value.replace(/,/g, '.')
      value = value.replace(/[^0-9.]/g, '')
      value = value.replace(/^([^.]*\.)|\./g, '$1')
      this.cashForm.amount = value
    },

    onCashCategoryChange(category) {
      this.cashForm.description = Number(category) === 6
        ? 'Cash Auszahlung'
        : 'Cash Einzahlung'
    },

    openDeleteDialog(item) {
      this.selectedStock = item
      this.deleteDialog = true
    },

    closeDeleteDialog() {
      this.selectedStock = null
      this.deleteDialog = false
    },

    async confirmDeleteStock() {
      if (!this.selectedStock) return

      try {
        await this.deleteStock(this.selectedStock.idstocks)
        this.editableStocks = this.editableStocks.filter(
          s => s.localKey !== this.selectedStock.localKey
        )
        this.selectedStock = null
      } catch (error) {
        console.error('Fehler beim Löschen des Stocks:', error)
      } finally {
        this.deleteDialog = false
      }
    },

    openUploadDialog(item) {
      this.uploadStock = item
      this.uploadFile = null
      this.uploadDialog = true
    },

    closeUploadDialog() {
      this.uploadDialog = false
      this.uploadStock = null
      this.uploadFile = null
    },

    onUploadFileSelected(e) {
      const files = e?.target?.files || e?.dataTransfer?.files || e?.files
      if (!files || !files.length) return
      this.uploadFile = files[0]
    },

    async confirmUploadSymbol() {
      if (!this.uploadStock || !this.uploadFile) return

      this.uploadStock.stocks_symbol_typ = this.uploadFile.name.split('.').pop().toLowerCase()

      const formData = new FormData()
      formData.append('file', this.uploadFile)
      formData.append('idstocks', this.uploadStock.idstocks)

      try {
        await this.$store.dispatch('createUploadSymbol', formData)

        this.imageVersions = {
          ...this.imageVersions,
          [this.uploadStock.idstocks]: Date.now()
        }

        this.closeUploadDialog()
      } catch (error) {
        console.error('Upload fehlgeschlagen', error)
      }
    },

    openPdfImportDialog() {
      this.$refs.pdfTransactionImport?.open()
    },

    async onPdfTransactionImported() {
      await this.$store.dispatch('getStocks')
    },

    async createStockFromItem(item, options = {}) {
      const today = new Date().toISOString()
      const neuerStock = {
        stocks_name: item.stocks_name,
        stocks_Handelsplatz: item.stocks_Handelsplatz,
        stocks_GoogleId: item.stocks_GoogleId,
        stocks_Kaufdatum: item.stocks_Kaufdatum || today,
        stocks_ISIN: item.stocks_ISIN,
        stocks_Kaufkurs: item.stocks_Kaufkurs,
        stocks_Menge: String(item.stocks_Menge ?? 0),
        stocks_Typ: item.stocks_Typ ?? 'Aktie',
        stocks_Status: item.stocks_Status ?? 1,
        stock_Umrechnungskurs: item.stock_Umrechnungskurs ?? 1,
        stock_Realsiert: item.stock_Realsiert ?? 0,
        stock_Aktuellerkurs: item.stock_Aktuellerkurs ?? 0,
        stocks_Land: item.stocks_Land,
        stocks_stoploss: item.stocks_stoploss ?? 0,
        stock_25ProzentVerkauflimit: item.stock_25ProzentVerkauflimit ?? 0,
        stock_delta1_prozent: item.stock_delta1_prozent ?? 0,
        stock_delta5_prozent: item.stock_delta5_prozent ?? 0,
        stock_delta20_prozent: item.stock_delta20_prozent ?? 0,
        user_iduser_id: item.user_iduser_id ?? this.users?.iduser ?? 1
      }

      const createdStock = await this.createStock(neuerStock)
      if (options.closeCreateMode) this.CreateModus = false
      if (options.refresh !== false) await this.$store.dispatch('getStocks')
      return createdStock
    },

    getCardcolor(item) {
      const mengeRaw = (item?.stocks_Menge ?? '').toString().trim().replace(',', '.')
      const menge = parseFloat(mengeRaw)

      const typ = (item?.stocks_Typ ?? '').toString().trim().toLowerCase()
      const handelsplatz = (item?.stocks_Handelsplatz ?? '').toString().trim().toLowerCase()
      const name = (item?.stocks_name ?? '').toString().trim().toLowerCase()

      if (handelsplatz === 'virtuell' || name.includes('virtuell')) {
        return 'grey'
      }

      if (!Number.isNaN(menge) && menge === 0) {
        return 'grey'
      }

      if (typ === 'rohstoff') return 'amber-lighten-3'
      if (typ === 'etf') return 'light-green-lighten-3'
      if (typ === 'aktie') return 'blue-lighten-3'
      if (typ === 'fonds') return 'teal'
      if (typ === 'cash') return 'blue-grey'
      if (typ === 'krypto') return 'orange'

      return 'grey'
    },

    getSymbolSrc(item) {
      const version = this.imageVersions[item.idstocks] || 0
      return `userdir/stocksymbols/symbol_${item.idstocks}.${item.stocks_symbol_typ}?v=${version}`
    },

    async createStockOnDB(item) {
      try {
        await this.createStockFromItem(item, { closeCreateMode: true })
      } catch (error) {
        console.error(error)
      }
    },

    async createTransaction(aenderungskennzeichen) {
      try {
        const TracForm = new FormData()
        TracForm.append('idstocks', this.editedItem.stocks_idstocks)
        TracForm.append('aenderungskennzeichen', aenderungskennzeichen)
        TracForm.append('menge', this.editedItem.menge)
        TracForm.append('gebuehr', this.editedItem.provision)
        TracForm.append('preis', this.editedItem.preis)

        this.txResult = await this.$store.dispatch('createTransaction', TracForm)
        this.showRawTxJson = false
        this.txResultDialog = true
        this.close()
      } catch (error) {
        this.txResultError = error
        this.txResult = error?.response?.data ?? {
          message: error?.message || 'Transaction fehlgeschlagen'
        }
        this.showRawTxJson = false
        this.txResultDialog = true
        console.error('TX Fehler', error)
      }
    },

    async updateStockOnDB(item) {
      try {
        const updatedstock = {
          idstocks: item.idstocks,
          stocks_name: item.stocks_name,
          stocks_Handelsplatz: item.stocks_Handelsplatz,
          stocks_GoogleId: item.stocks_GoogleId,
          stocks_Kaufdatum: item.stocks_Kaufdatum,
          stocks_ISIN: item.stocks_ISIN,
          stocks_Kaufkurs: item.stocks_Kaufkurs,
          stocks_Menge: String(item.stocks_Menge ?? 0),
          stocks_Typ: item.stocks_Typ,
          stocks_Status: item.stocks_Status,
          stock_Umrechnungskurs: item.stock_Umrechnungskurs,
          stock_Realsiert: item.stock_Realsiert,
          stock_Aktuellerkurs: parseFloat(item.stock_Aktuellerkurs || 0),
          stocks_Land: item.stocks_Land,
          stocks_stoploss: item.stocks_stoploss,
          stock_25ProzentVerkauflimit: item.stock_25ProzentVerkauflimit,
          stock_delta1_prozent: item.stock_delta1_prozent,
          stock_delta5_prozent: item.stock_delta5_prozent,
          stock_delta20_prozent: item.stock_delta20_prozent,
          user_iduser_id: 1
        }

        await this.updateStock(updatedstock)
      } catch (error) {
        console.error(error)
      }
    },

    async urladungStockOnDB(item) {
      try {
        const formData = new FormData()
        formData.append('idstocks', item.idstocks)

        this.dialogUrladungRunning = true

        const response = await this.$store.dispatch('createUrladung', formData)
        this.dialogUrladungRunning = false

        if ((response?.download_stockhistory || '').slice(0, 2) === '-E') {
          this.dialogUrladungAlert = true
        }
      } catch (error) {
        console.error('Urladung fehlgeschlagen', error)
        this.dialogUrladungRunning = false
      }
    },

    createStockGUI() {
      const key = `new-${++this.newStockCounter}`

      const neuerStock = {
        idstocks: `new-${this.newStockCounter}`,
        localKey: key,
        isNew: true,
        stocks_name: '???',
        stocks_Handelsplatz: '???',
        stocks_GoogleId: '???',
        stocks_Kaufdatum: '2020-02-08T16:15:13Z',
        stocks_ISIN: '???',
        stocks_Kaufkurs: 0,
        stocks_Menge: '0',
        stocks_Status: 1,
        stocks_Typ: 'Aktie',
        stock_Umrechnungskurs: 1,
        stock_Realsiert: '0',
        stock_Aktuellerkurs: 0,
        stocks_Land: '???',
        stocks_stoploss: '0',
        stock_25ProzentVerkauflimit: '0',
        stock_delta1_prozent: 0.1,
        stock_delta5_prozent: 11.55,
        stock_delta20_prozent: 11.55,
        user_iduser: {
          iduser: 0,
          user_username: 'x',
          full_name: 'x',
          user_UUID: 'x',
          user_Seriennummer_Android: 'x'
        },
        stock_Aktuellerkurs_gesamt: 0,
        stock_StopLoss_Euro: 0
      }

      this.CreateModus = true
      this.editableStocks.unshift(neuerStock)
      this.zeigeStocksAllerUser = true
    },

    openBuyDialog(item) {
      this.editedItem = {
        ...this.defaultEditedItem,
        stocks_idstocks: item.idstocks,
        aenderungskennzeichen: 1
      }
      this.dialog = true
    },

    openSellDialog(item) {
      this.editedItem = {
        ...this.defaultEditedItem,
        stocks_idstocks: item.idstocks,
        aenderungskennzeichen: 2
      }
      this.dialogSubtract = true
    },

    openCashDialog(item) {
      this.cashStock = item
      this.cashForm = {
        category: 5,
        amount: '',
        date: this.todayIsoDate(),
        description: 'Cash Einzahlung'
      }
      this.cashDialog = true
    },

    closeCashDialog() {
      this.cashDialog = false
      this.cashStock = null
      this.cashForm = {
        category: 5,
        amount: '',
        date: '',
        description: 'Cash Einzahlung'
      }
    },

    async saveCashTransaction() {
      if (!this.canSaveCashTransaction) return

      const amount = Number(String(this.cashForm.amount || '').replace(',', '.'))
      const category = Number(this.cashForm.category)
      const description = String(this.cashForm.description || '').trim() ||
        (category === 6 ? 'Cash Auszahlung' : 'Cash Einzahlung')

      try {
        const { data } = await axios.post('/manualtransaction', {
          stocks_transactions_category: category,
          stocks_idstocks: Number(this.cashStock.idstocks),
          stocks_menge: 1,
          stocks_gebuehr: 0,
          stocks_transactions_preis: amount,
          stocks_transactions_datum: `${this.cashForm.date || this.todayIsoDate()}T00:00:00`,
          stocks_transactions_beschreibung: description
        })

        this.txResult = data
        this.showRawTxJson = false
        this.txResultDialog = true
        this.closeCashDialog()
        await this.$store.dispatch('getStocks')
      } catch (error) {
        this.txResultError = error
        this.txResult = error?.response?.data ?? {
          message: error?.message || 'Cash-Buchung fehlgeschlagen'
        }
        this.showRawTxJson = true
        this.txResultDialog = true
        console.error('Cash TX Fehler', error)
      }
    },

    goToAnalyzer(item) {
      if (!item?.idstocks) return
      this.$router.push({
        name: 'Analyzer',
        params: {
          idstocks: item.idstocks,
          stocks_name: item.stocks_name || ''
        }
      })
    },

    close() {
      this.dialog = false
      this.dialogSubtract = false
      setTimeout(() => {
        this.editedItem = { ...this.defaultEditedItem }
        this.editedIndex = -1
      }, 300)
    }
  }
}
</script>

<style scoped>
.stocks-actions {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}

.stocks-user-filter {
  flex: 0 0 auto;
  min-width: 128px;
}

.create-stock-toolbar-btn {
  color: #ffffff;
  font-weight: 700;
}

.create-stock-submit-btn {
  color: #102016;
  font-weight: 700;
}

.stock-selector-wrap {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  align-items: center;
  justify-content: center;
  padding: 6px 10px;
  max-width: 100%;
  overflow: visible;
}

.stock-btn {
  min-width: 0;
  padding-inline: 6px;
}

.stock-menu-card {
  width: min(720px, calc(100vw - 24px));
  max-height: 70vh;
  overflow-y: auto;
}

.stock-selector-wrap--sheet {
  justify-content: flex-start;
  padding: 0;
}

.stocks-scroll-wrap {
  max-height: 800px;
  overflow-y: auto;
}

.stock-anchor {
  width: 100%;
}

.stock-panel-title-text {
  min-width: 0;
  display: flex;
  flex-direction: column;
}

.stock-title-row {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 6px;
}

.stock-title {
  font-weight: 700;
  font-size: 16px;
  line-height: 1.2;
  margin-bottom: 2px;
}

.stock-subtitle {
  opacity: 0.95;
  font-size: 13px;
  line-height: 1.2;
}

.stock-value-header {
  font-weight: 700;
}

</style>
